export const palette = {
  primary: {
    100: '#c3c9fb',
    200: '#a4acf8',
    300: '#8d97f8',
    400: '#7380fb',
    500: '#5564f8',

    main: '#01c46a',
    dark: '#1c2ed1',
    light: '#c3c9fb'
  },
  secondary: {
    100: '#F9F9F9',
    200: '#ECEFF5',
    300: '#E5EAF2',
    400: '#818999',
    500: '#232833',

    main: '#232833',
    light: '#F9F9F9'
  },
  error: {
    main: '#ef4770'
  },
  warning: {
    main: '#ed6c02'
  },
  success: {
    main: '#11b886'
  },
  info: {
    main: '#07caeb'
  },
  divider: '#E5EAF2',
  background: {
    default: '#070b0d',
    paper: '#191f24'
  },
  text: {
    default: '#04bf5e',
    primary: '#fff',
    secondary: '#E5EAF2',
    disabled: '#818999'
  },
  border: {
    default: '#E5EAF2'
  },
  mode: 'light'
};
